/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetSettingsResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { UpdateSettingsRequestSettings } from '../models';
// @ts-ignore
import type { UpdateSettingsResponse } from '../models';
/**
 * SettingsAPIApi - axios parameter creator
 * @export
 */
export const SettingsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get organization settings
         * @summary Get organization settings.
         * @param {string} organizationId ID of the organization to get settings for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsAPIGetSettings: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('settingsAPIGetSettings', 'organizationId', organizationId)
            const localVarPath = `/organization-management/v1/organizations/{organizationId}/settings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update organization settings
         * @summary Update organization settings.
         * @param {string} organizationId ID of the organization to update settings for
         * @param {UpdateSettingsRequestSettings} updateSettingsRequestSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsAPIUpdateSettings: async (organizationId: string, updateSettingsRequestSettings: UpdateSettingsRequestSettings, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('settingsAPIUpdateSettings', 'organizationId', organizationId)
            // verify required parameter 'updateSettingsRequestSettings' is not null or undefined
            assertParamExists('settingsAPIUpdateSettings', 'updateSettingsRequestSettings', updateSettingsRequestSettings)
            const localVarPath = `/organization-management/v1/organizations/{organizationId}/settings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSettingsRequestSettings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingsAPIApi - functional programming interface
 * @export
 */
export const SettingsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettingsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Get organization settings
         * @summary Get organization settings.
         * @param {string} organizationId ID of the organization to get settings for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settingsAPIGetSettings(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settingsAPIGetSettings(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsAPIApi.settingsAPIGetSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update organization settings
         * @summary Update organization settings.
         * @param {string} organizationId ID of the organization to update settings for
         * @param {UpdateSettingsRequestSettings} updateSettingsRequestSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settingsAPIUpdateSettings(organizationId: string, updateSettingsRequestSettings: UpdateSettingsRequestSettings, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settingsAPIUpdateSettings(organizationId, updateSettingsRequestSettings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsAPIApi.settingsAPIUpdateSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SettingsAPIApi - factory interface
 * @export
 */
export const SettingsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettingsAPIApiFp(configuration)
    return {
        /**
         * Get organization settings
         * @summary Get organization settings.
         * @param {SettingsAPIApiSettingsAPIGetSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsAPIGetSettings(requestParameters: SettingsAPIApiSettingsAPIGetSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSettingsResponse> {
            return localVarFp.settingsAPIGetSettings(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update organization settings
         * @summary Update organization settings.
         * @param {SettingsAPIApiSettingsAPIUpdateSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsAPIUpdateSettings(requestParameters: SettingsAPIApiSettingsAPIUpdateSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateSettingsResponse> {
            return localVarFp.settingsAPIUpdateSettings(requestParameters.organizationId, requestParameters.updateSettingsRequestSettings, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for settingsAPIGetSettings operation in SettingsAPIApi.
 * @export
 * @interface SettingsAPIApiSettingsAPIGetSettingsRequest
 */
export interface SettingsAPIApiSettingsAPIGetSettingsRequest {
    /**
     * ID of the organization to get settings for
     * @type {string}
     * @memberof SettingsAPIApiSettingsAPIGetSettings
     */
    readonly organizationId: string
}

/**
 * Request parameters for settingsAPIUpdateSettings operation in SettingsAPIApi.
 * @export
 * @interface SettingsAPIApiSettingsAPIUpdateSettingsRequest
 */
export interface SettingsAPIApiSettingsAPIUpdateSettingsRequest {
    /**
     * ID of the organization to update settings for
     * @type {string}
     * @memberof SettingsAPIApiSettingsAPIUpdateSettings
     */
    readonly organizationId: string

    /**
     * 
     * @type {UpdateSettingsRequestSettings}
     * @memberof SettingsAPIApiSettingsAPIUpdateSettings
     */
    readonly updateSettingsRequestSettings: UpdateSettingsRequestSettings
}

/**
 * SettingsAPIApi - object-oriented interface
 * @export
 * @class SettingsAPIApi
 * @extends {BaseAPI}
 */
export class SettingsAPIApi extends BaseAPI {
    /**
     * Get organization settings
     * @summary Get organization settings.
     * @param {SettingsAPIApiSettingsAPIGetSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsAPIApi
     */
    public settingsAPIGetSettings(requestParameters: SettingsAPIApiSettingsAPIGetSettingsRequest, options?: RawAxiosRequestConfig) {
        return SettingsAPIApiFp(this.configuration).settingsAPIGetSettings(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update organization settings
     * @summary Update organization settings.
     * @param {SettingsAPIApiSettingsAPIUpdateSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsAPIApi
     */
    public settingsAPIUpdateSettings(requestParameters: SettingsAPIApiSettingsAPIUpdateSettingsRequest, options?: RawAxiosRequestConfig) {
        return SettingsAPIApiFp(this.configuration).settingsAPIUpdateSettings(requestParameters.organizationId, requestParameters.updateSettingsRequestSettings, options).then((request) => request(this.axios, this.basePath));
    }
}

